import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { Firestore, collection, query, where, getDocs } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private currentUserSubject = new BehaviorSubject<any>(null);
  public currentUser$ = this.currentUserSubject.asObservable();
  public currentUser = this.currentUserSubject.asObservable();

  constructor(
    private router: Router,
    private firestore: Firestore
  ) {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      this.currentUserSubject.next(JSON.parse(storedUser));
    }
  }

  async login(email: string, password: string): Promise<boolean> {
    try {
      console.log('Iniciando proceso de login...');
      console.log('Email:', email);
      
      const usersRef = collection(this.firestore, 'usuarios');
      console.log('Colección de usuarios obtenida');
      
      const q = query(usersRef, 
        where('email', '==', email),
        where('password', '==', password)
      );
      console.log('Query construida');
      
      const querySnapshot = await getDocs(q);
      console.log('Query ejecutada');
      console.log('Documentos encontrados:', querySnapshot.size);
      
      if (!querySnapshot.empty) {
        const userDoc = querySnapshot.docs[0];
        const userData = userDoc.data();
        console.log('Datos del usuario encontrado:', userData);
        
        const user = {
          id: userDoc.id,
          email: userData['email'] || '',
          password: userData['password'] || '',
          rol: userData['role'] || userData['rol'] || 'auxiliar',
          identificador: userData['identificador'] || '',
          nombre: userData['nombre'] || ''
        };
        
        console.log('Usuario procesado:', user);
        console.log('Guardando usuario en localStorage...');
        localStorage.setItem('user', JSON.stringify(user));
        this.currentUserSubject.next(user);
        console.log('Usuario guardado correctamente');
        
        // Redirigir según el rol
        let redirectPath = '/dashboard';
        if (user.rol === 'profesor') {
          redirectPath = '/profesor';
        } else if (user.rol === 'admin') {
          redirectPath = '/dashboard';
        } else {
          redirectPath = '/dashboard';
        }
        
        console.log(`Intentando redirección a ${redirectPath}...`);
        await this.router.navigate([redirectPath]);
        console.log('Redirección completada');
        
        return true;
      }
      
      console.log('No se encontró ningún usuario con las credenciales proporcionadas');
      return false;
    } catch (error) {
      console.error('Error detallado en el proceso de login:', error);
      throw error;
    }
  }

  logout(): void {
    console.log('Iniciando proceso de logout...');
    localStorage.removeItem('user');
    this.currentUserSubject.next(null);
    console.log('Usuario eliminado del localStorage');
    this.router.navigate(['/login']);
    console.log('Redirección a login completada');
  }

  isAuthenticated(): boolean {
    const isAuth = !!this.currentUserSubject.value;
    console.log('Verificación de autenticación:', isAuth);
    return isAuth;
  }

  getCurrentUser(): any {
    const user = this.currentUserSubject.value;
    console.log('Usuario actual:', user);
    return user;
  }
}